var AppointmentsRescheduleDataTestId = /* @__PURE__ */ ((AppointmentsRescheduleDataTestId2) => {
  AppointmentsRescheduleDataTestId2["APPOINTMENT_RESCHEDULE_CONFIRM_PROCEDURE"] = "appointments--reschedule-confirm-procedure";
  AppointmentsRescheduleDataTestId2["APPOINTMENT_RESCHEDULE_CONFIRM_DATE"] = "appointments--reschedule-confirm-date";
  AppointmentsRescheduleDataTestId2["APPOINTMENT_RESCHEDULE_CONFIRM_PROFESSIONAL"] = "appointments--reschedule-confirm-professional";
  AppointmentsRescheduleDataTestId2["APPOINTMENT_RESCHEDULE_CONFIRM_HOUR"] = "appointments--reschedule-confirm-hour";
  AppointmentsRescheduleDataTestId2["APPOINTMENT_RESCHEDULE_BUTTON_BACK"] = "appointments--reschedule-button-back";
  AppointmentsRescheduleDataTestId2["APPOINTMENT_RESCHEDULE_BUTTON_SUBMIT"] = "appointments--rechedule-button-submit";
  AppointmentsRescheduleDataTestId2["APPOINTMENT_RESCHEDULE_CALENDAR"] = "appointments--reschedule-calendar";
  AppointmentsRescheduleDataTestId2["APPOINTMENT_RESCHEDULE_TABS"] = "appointments--reschedule-tabs";
  return AppointmentsRescheduleDataTestId2;
})(AppointmentsRescheduleDataTestId || {});
export {
  AppointmentsRescheduleDataTestId
};
